<template>
  <div>
    <ver-mis-booking-por-aceptar class="mt-3" :data="data" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { getVerMisBookingsPorAceptar, getVerMisBookingsPorAceptarFiltrados } from "../../../constants/lineas";
import VerMisBookingPorAceptar from "../../../components/tablas/lineas/VerMisBookingPorAceptar";

export default {
  components: { VerMisBookingPorAceptar },
  data() {
    return {
      data: []
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", ["dataDatatableVerMisBookingsPorAceptarFiltrada", "flagFiltersBookings"]),
  },
  methods: {
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoading",
      "ActionSetLoadingTable",
    ]),
    ...mapActions("lineas", ["actionSetDatatableVerMisBookingsPorAceptar"]),
    ...mapActions("lineas", [
      "actionSetDataListaPOD",
      "actionSetDataListaSemana",
      "actionSetDataListaAnio",
      "actionSetDataListaProducto",
    ]),
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
    async setDataPorAceptarFiltro(){

      const filters = {
        id: this.$route.query.id_by_country ?? null,
        anio: null,
        pod: null,
        semana: null,
        producto: null
      };

      const dataFiltrada = await getVerMisBookingsPorAceptarFiltrados(filters);

      await this.actionSetDatatableVerMisBookingsPorAceptar(dataFiltrada);

    },
    async getBookingPorAceptar() {

      this.ActionSetLoadingTable(true);

      const dataDB = await getVerMisBookingsPorAceptar();

      if (Object.keys(this.$route.query).length > 0) {

        await this.setDataPorAceptarFiltro();

      } else {

        await this.actionSetDatatableVerMisBookingsPorAceptar(dataDB.data_table);

      }

      this.actionSetDataListaPOD(dataDB.filtro_pod);
      this.actionSetDataListaSemana(dataDB.filtro_semanas);
      this.actionSetDataListaAnio(dataDB.filtro_anio);
      this.actionSetDataListaProducto(dataDB.filtro_producto);

      this.ActionSetLoadingTable(false);
    },
  },
  created() {
    this.actualizarURL();
    this.getBookingPorAceptar();
  },
  watch: {
    dataDatatableVerMisBookingsPorAceptarFiltrada: function (_new) {
      if (_new) {
        this.data = _new;
      }
    },

    flagFiltersBookings: function(_new) {
      if (!_new) {
        this.getBookingPorAceptar();
      }
    }

  },
};
</script>
<style></style>
